import React from 'react';
import { Router } from '@uhg-abyss/web/ui/Router';
import { Text } from '@uhg-abyss/web/ui/Text';
import { useAuth } from '../../auth';

export const AdminShell = () => {
  const { session } = useAuth();

  if (!session) {
    return null; // ProtectedShell above us already handles unauthenticated redirect
  }

  if (!session.isAdmin) {
    return (
      <div style={{ padding: '2rem' }}>
        <Text style={{ fontSize: '1.2rem', fontWeight: 600 }}>
          Access denied
        </Text>
        <Text>
          You do not have the administrator access required for this section.
        </Text>
      </div>
    );
  }

  return <Router.Outlet />;
};
